import { Message } from 'primereact/message';
import React, { FocusEvent } from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

interface PhoneNumberFieldProps {
  label?: string;
  value: string;
  onChange: (phone: string, country: any) => void;
  onBlur?: (e: FocusEvent<any, Element>) => void;
  required?: boolean;
  disabled?: boolean;
  className?: string;
  placeholder?: string;
  error?: string;
}

const PhoneNumberField: React.FC<PhoneNumberFieldProps> = (props: PhoneNumberFieldProps) => {
  return (
    <div className={`p-field phone-numer-field ${props.className} ${props.error && 'invalid'}`}>
      {props.label && (
        <label className="form-label">
          {props.label} {props.required && <span className="required-field">*</span>}
        </label>
      )}

      <PhoneInput
        country="in"
        value={props.value}
        onChange={(phone, country) => props.onChange(phone, country)}
        onBlur={props.onBlur}
        disabled={props.disabled}
        placeholder="Enter here"
        onlyCountries={['in']}
        preferredCountries={['in']}
        countryCodeEditable={false}
      />
      {props.error &&   <Message severity="error" text={props.error} />}
    </div>
  );
};

export default PhoneNumberField;
